import { Pharmacy } from "../types/pharmacy";

export const getPharmacySelectLabel = (pharmacy: Pharmacy) =>
  `${pharmacy?.code} ${pharmacy?.branchNumber} - ${pharmacy?.businessName} (${pharmacy?.postcode})`;